import * as React from "react";
import {Icon, IConcreteIcon} from "../Icon";

export const AmexIcon = ({style}: IConcreteIcon) => <Icon file="/icons/payment_methods/amex.svg" style={style} />;
